import { useEffect, useRef, useState } from 'react';

export function useSplashScreenDelay(readyDefault: boolean, condition: boolean, delay: number) {
  const [show, setShow] = useState(readyDefault);
  const mountTime = useRef(Date.now());

  useEffect(() => {
    if (condition) {
      const elapsed = Date.now() - mountTime.current;
      const timer = setTimeout(() => setShow(false), Math.max(0, delay - elapsed));
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [condition, delay]);

  return { show };
}
